module.exports = __webpack_public_path__ + "static/media/IMG_20181114_212343_edited.24f4a592.jpg";